import { render, staticRenderFns } from "./ContentGdDetailComponent.vue?vue&type=template&id=20d4e74d&scoped=true"
import script from "./ContentGdDetailComponent.vue?vue&type=script&lang=js"
export * from "./ContentGdDetailComponent.vue?vue&type=script&lang=js"
import style0 from "./ContentGdDetailComponent.vue?vue&type=style&index=0&id=20d4e74d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d4e74d",
  null
  
)

export default component.exports